module.exports = __webpack_public_path__ + "media/images/icons/print-b04c4767f955674c8cf49206bb8a938a.svg";